@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <p-autocomplete
        [inputId]="inputId()"
        [placeholder]="placeholder() ?? ''"
        [suggestions]="suggestions()"
        [completeOnFocus]="true"
        [showEmptyMessage]="false"
        fluid
        [invalid]="showInvalid()"
        [disabled]="disabled()"
        [ngModel]="value()"
        (ngModelChange)="handleChange($event)"
        (completeMethod)="complete.emit($event.query)"
        (onBlur)="markTouched()"
        [ngModelOptions]="standaloneNgModel" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
